import styled from 'styled-components';

export const PageTitleWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const PageTitleH1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
`;

interface TableLanguageProps {
    notSet?: boolean;
};

export const TableLanguage = styled.div<TableLanguageProps>`
    padding: 4px 8px;
    background-color: ${props => props.notSet ? '#ECEFF1' : '#FFF9C4'};
    text-transform: ${props => props.notSet ? 'uppercase' : 'capitalize'};
    color: ${props => props.notSet ? '#90A4AE' : '#000000'};
`;

export const PhotosWrap = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 16px;
`;